import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
// import Page from "../../helpers/config";
import { message } from "../../redux/actions/toastActions";
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import Pagination from "../common/Pagination";
import ModalPopup from "../common/Modal";
import { Formik, Form, Field, ErrorMessage } from "formik";
import crossIcon from "../../assets/Icons/cross.svg";
import pdfIcon from "../../assets/Icons/pdf.svg";
// import { feesStructureSchema } from "../../helpers/validations";
import DeleteModal from "../common/DeleteModal";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import { toast } from "sonner";
const Yup = require("yup");

const FeeStructure = () => {
  const dispatch = useDispatch();
  const fileInputRef = useRef();
  // const [open, setOpen] = useState(false);
  // const [modalChatView, setmodalChatView] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setperPage] = useState(6);
  const [currentPage, setcurrentPage] = useState(1);
  const [Data, setData] = useState([]);
  const [isLoading, setIsloading] = useState(true);
  const [refresh, setRefresh] = useState(true);
  // const [modalForm, setModalForm] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  // const [noteIdToDelete, setNoteIdToDelete] = useState(null);
  const [modalswitch, setmodalswitch] = useState(false);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [formInitialValues, setFormInitialValues] = useState({
    title: "",
    files: [],
  });
  const [Type, setType] = useState("");
  const [existingFiles, setExistingFiles] = useState([]); // Files from DB
  const [updatedFiles, setUpdatedFiles] = useState([]); // New Files (File objects)
  const [deletedFiles, setDeletedFiles] = useState([]); // Files removed by user

  const [modalOpenDelete, setmodalOpenDelete] = useState(false);
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);
  console.log("permissions", permissions);
  const menuRefs = useRef([]);
  const schoolId = localStorage.getItem("activeSchoolId");
  const isAccessible =
    role == "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("view_Admissions") || permissions?.includes("view_School"))) ||
    false;
  const addPermission =
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_Admissions") || permissions?.includes("edit_School"))) ||
    false;
  const deletePermission =
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("delete_Admissions") || permissions?.includes("delete_School"))) ||
    false;
  const mode = localStorage.getItem("mode");

  const handlePageChange = (page) => {
    setcurrentPage(page);
    feeStructureData(page, perPage);
  };

  const resetFeeStructureForm = () => {
    setSelectedId(null);
    setSelectedFile(null);
    setExistingFiles([]);
    setUpdatedFiles([]);
    setDeletedFiles([]);
    setFormInitialValues({
      title: "",
      files: [],
    });
  };
  const feesStructureSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    files: Yup.array()
      .test("max-files", "You can only upload one file.", (value, context) => {
        // Check if there are already files uploaded (existing + new ones)
        const totalFiles = existingFiles.length + (value ? value.length : 0);

        // If total files exceed 1, show error
        return totalFiles <= 1;
      })
      .test(
        "is-uploaded",
        "Please upload fee structure PDF before saving.",
        (value, context) => {
          // If there are any existing files, skip this error
          if (existingFiles.length > 0 || (value && value.length > 0)) {
            return true;
          }
          return false;
        }
      )
      .required("Please upload fee structure PDF before saving."), // Keeps the "Please upload" error if no files are uploaded
  });

  const handleRowsPerPageChange = (rows) => {
    setperPage(rows);
    setcurrentPage(1);
    feeStructureData(1, rows);
  };

  const feeStructureData = (currentPage, perPage) => {
    setIsloading(true);
    Postdata(HttpService.fee_structure_list, {
      page: currentPage,
      perpage: perPage,
      //   board_member_id: boardMemberId,
      //   startDate: startDate,
      //   endDate: endDate,
      school_id: schoolId,
    })
      .then((response) => {
        if (response.status === 200) {
          setData(response.data.feeStructure);
          setTotalRows(response.data.count);
          setIsloading(false);
        } else {
          setIsloading(false);
          // dispatch(message(response.message));
        }
      })
      .catch((e) => {
        setIsloading(false);
        // dispatch(message(e.message));
      });
  };

  useEffect(() => {
    feeStructureData(currentPage, perPage);
  }, [refresh]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      let clickedInside = false;
      menuRefs.current.forEach((ref) => {
        if (ref && ref.contains(event.target)) {
          clickedInside = true;
        }
      });
      if (!clickedInside) {
        setOpenMenuIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDelete = (id) => {
    if (!id) return;

    setmodalOpenDelete(false);
    setIsloading(true);

    Postdata(HttpService.fee_structure_delete, { id, school_id: schoolId })
      .then((res) => {
        toast.success(res.message);
        // dispatch(message(res.message));
        setRefresh((prev) => !prev);
      })
      .catch((error) => {
        console.error("Delete failed:", error);
        // dispatch(message("Failed to delete. Please try again."));
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const handleFeeStructure = (
    values,
    setSubmitting,
    resetForm,
    setmodalswitch,
    setRefresh,
    dispatch
  ) => {
    if (existingFiles.length + updatedFiles.length === 0) {
      dispatch(message("Please upload at least one PDF file."));
      setSubmitting(false);
      return;
    }

    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("school_id", schoolId);
    if (selectedId) {
      formData.append("id", selectedId);
    }

    // if (selectedFile?.length) {
    //   selectedFile.forEach((file) => {
    //     formData.append("file", file); // use same key if API expects `file[]`
    //   });
    // }

    updatedFiles.forEach((file) => {
      formData.append("file", file);
    });

    existingFiles.forEach((file) => {
      formData.append("existingFiles[]", file);
    });

    deletedFiles.forEach((file) => {
      formData.append("deletedFiles[]", file);
    });

    console.log("Harshal01-----");
    Postdata(HttpService.fee_structure_add, formData)
      .then((response) => {
        if (response.status === 200) {
          // dispatch(message("Fee Structure added successfully"));
          toast.success(response.message);
          setmodalswitch(false);
          setRefresh((prev) => !prev);
          resetForm();
          setSelectedId(null);
          setSelectedFile(null);
          setExistingFiles([]);
          setUpdatedFiles([]);
          setDeletedFiles([]);
        }
        // else {
        //   dispatch(message(response.message));
        // }
        setSubmitting(false);
      })
      .catch((error) => {
        // dispatch(message(error.message));
        setSubmitting(false);
      });
  };

  return (
    <>
      <div className="flex justify-between items-center">
        <span className="label-subtitle">Fee Structure</span>
        {addPermission && (
          // <button
          //   className="button-small-primary"
          //   onClick={() => {
          //     setSelectedId(null);
          //     setFormInitialValues({ title: "", files: [] });
          //     setmodalswitch(true);
          //     setType("Add");
          //   }}

          <button
            className="button-small-primary"
            onClick={() => {
              resetFeeStructureForm();
              setType("Add");
              setmodalswitch(true);
            }}
          >
            + Add
          </button>
        )}
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mt-2">
        {isLoading ? (
          <div className="w-full col-span-3 flex justify-center items-center">
            Loading...
          </div>
        ) : (
          Data?.map((subject, index) => (
            <div
              key={index}
              className="relative bg-white p-[15px] rounded-xl hover:shadow-lg transition"
            >
              {/* PDF Icons */}
              <div className="flex gap-1">
                {subject.file?.map((fileUrl, i) => (
                  <a
                    key={i}
                    href={fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={pdfIcon}
                      alt="PDF"
                      className="w-10 h-10 cursor-pointer"
                    />
                  </a>
                ))}
              </div>
              <div className="relative mt-2">
                {/* Three Dots Menu */}
                {(addPermission || deletePermission) && (
                  <div className="absolute top-0 right-[2px]">
                    <button onClick={() => toggleMenu(index)}>
                      <img
                        src={HiOutlineDotsVertical}
                        className="text-gray-500 hover:text-black"
                      />
                    </button>

                    {openMenuIndex === index && (
                      <div
                        ref={(el) => (menuRefs.current[index] = el)}
                        className="absolute bottom-[-10px] right-4 w-28 bg-white shadow-md border rounded-xl z-10" // Increased width to match button sizes
                      >
                        {addPermission && (
                          <button
                            onClick={() => {
                              setSelectedId(Data[index]._id);
                              setFormInitialValues({
                                title: Data[index].title,
                                files: [],
                              });
                              setSelectedFile(Data[index].file);
                              setmodalswitch(true);
                              setExistingFiles(Data[index].file); // Assume this is an array of URLs or IDs
                              setUpdatedFiles([]); // Clear previous
                              setDeletedFiles([]);
                              setType("Edit");
                            }}
                            className="block w-full text-left px-3 py-2 text-sm rounded-t-xl hover:bg-gray-100"
                          >
                            Edit
                          </button>
                        )}
                        {deletePermission && (
                          <button
                            className="block w-full text-left px-3 py-2 text-sm rounded-b-xl hover:bg-gray-100"
                            onClick={() => {
                              setmodalOpenDelete(true);
                              setSelectedId(Data[index]._id);
                            }}
                          >
                            Delete
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Title & Description */}
                <div className="mb-0">
                  <h3 className="font-semibold text-card-title text-gray-800 overflow-hidden flex gap-2">
                    {subject.title?.length > 17
                      ? `${subject.title.slice(0, 17)}...`
                      : subject.title}
                  </h3>

                  <p className="mt-1 text-card-body text-gray-600 line-clamp-3 ">
                    {subject.description}
                  </p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* <ModalPopup
        className="alert-box-popup"
        show={modalswitch}
        size="md"
        onHide={() => setmodalswitch(false)}
        heading="Are you sure?"
      > */}
      <ModalPopup
        show={modalswitch}
        size="md"
        onHide={() => {
          resetFeeStructureForm();
          setmodalswitch(false);
        }}
      >
        <div className="text-start flex justify-center flex-col items-center gap-3 px-3 relative ">
          {/* <img
            src={crossIcon}
            alt=""
            className="absolute top-2 right-2 cursor-pointer"
            onClick={() => {
              setmodalswitch(false);
              setSelectedId(null);
              setSelectedFile(null);
              setExistingFiles([]);
              setUpdatedFiles([]);
              setDeletedFiles([]);
            }}
          /> */}
          <img
            src={crossIcon}
            alt=""
            className="absolute top-2 right-2 cursor-pointer"
            onClick={() => {
              resetFeeStructureForm();
              setmodalswitch(false);
            }}
          />
          <h3>{Type} Fee Structure</h3>
          <Formik
            initialValues={formInitialValues}
            enableReinitialize
            validationSchema={feesStructureSchema}
            onSubmit={(values, { setSubmitting, resetForm }) =>
              handleFeeStructure(
                values,
                setSubmitting,
                resetForm,
                setmodalswitch,
                setRefresh,
                dispatch
              )
            }
          >
            {({ isSubmitting, setFieldValue, errors, touched }) => (
              <Form className="w-full">
                {/* Title Field */}
                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    Title <span className="text-red-500">*</span>
                  </label>
                  <Field
                    type="text"
                    name="title"
                    placeholder="Enter Title"
                    className="input-field-grey"
                    maxLength={50}
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="text-red-500"
                  />
                </div>

                {/* File Upload */}
                <div className="mt-2">
                  <label className="block mb-1 font-medium text-gray-700">
                    Upload Files <span className="text-red-500">*</span>
                  </label>
                  <div className="relative flex-1">
                    <input
                      type="text"
                      name="upload-file"
                      placeholder="Select File"
                      className="input-field-grey"
                      readOnly
                      value={
                        updatedFiles.length > 0
                          ? updatedFiles[0].name
                          : existingFiles.length > 0
                            ? existingFiles[0].split("/").pop()
                            : ""
                      }
                    />
                    <button
                      type="button"
                      onClick={() => fileInputRef.current.click()}
                      disabled={existingFiles.length + updatedFiles.length >= 1} // Disable button if one file is already uploaded
                      className={`absolute top-1/2 right-3 -translate-y-1/2 font-semibold ${existingFiles.length + updatedFiles.length >= 1
                        ? "text-gray-400 cursor-not-allowed"
                        : "text-orange-600"
                        }`}
                    >
                      Upload
                    </button>
                  </div>

                  <input
                    type="file"
                    ref={fileInputRef}
                    name="files"
                    multiple={false}
                    accept=".pdf"
                    onChange={(e) => {
                      const selectedFiles = Array.from(e.target.files);

                      const maxSize = 5 * 1024 * 1024; // 10MB
                      const maxFiles = 1;
                      let validFiles = [];

                      // Clear existing files when a new file is uploaded
                      if (selectedFiles.length > 0) {
                        setExistingFiles([]); // Clear the existing files
                      }

                      // Ensure we are not uploading more than one file in total
                      if (
                        existingFiles.length + selectedFiles.length >
                        maxFiles
                      ) {
                        dispatch(
                          message(
                            `You can upload a maximum of ${maxFiles} file.`
                          )
                        );
                        return;
                      }

                      selectedFiles.forEach((file) => {
                        if (file.type !== "application/pdf") {
                          // dispatch(message(`File is not a valid PDF file.`));
                          toast.warning(`File is not a valid PDF file.`);

                          return;
                        }
                        if (file.size > maxSize) {
                          // dispatch(message(`"${file.name}" exceeds 5MB.`));
                          toast.warning(`"${file.name}" must not exceed 5MB`);

                          return;
                        } else {
                          validFiles.push(file);
                        }
                      });

                      if (validFiles.length > 0) {
                        // If there is an existing file, add it to deletedFiles
                        if (existingFiles.length > 0) {
                          setDeletedFiles((prev) => [
                            ...prev,
                            ...existingFiles.map((file) => file.name), // Assuming `file.name` represents the file to delete
                          ]);
                          setExistingFiles([]); // Clear the existing files
                        }

                        setUpdatedFiles([validFiles[0]]); // Update only the new file
                        // Set the selected file to Formik so validation can happen
                        setFieldValue("files", validFiles);
                      }

                      e.target.value = null; // Reset input
                    }}
                    className="hidden"
                  />
                  <ErrorMessage
                    name="files"
                    component="div"
                    className="text-red-500"
                  />
                </div>

                {/* File Previews */}
                <div className="flex flex-wrap gap-[14px] mt-3">
                  {/* Existing Files Preview */}
                  {existingFiles.map((file, index) => (
                    <div
                      key={`existing-${index}`}
                      className="relative rounded-md flex items-center justify-center"
                    >
                      <img src={pdfIcon} alt="PDF" className="w-10 h-10" />
                      <button
                        type="button"
                        onClick={() => {
                          setDeletedFiles((prev) => [...prev, file]);
                          setExistingFiles((prev) =>
                            prev.filter((_, i) => i !== index)
                          );
                        }}
                        className="absolute -top-2 -right-2 bg-black text-white rounded-full w-5 h-5 text-xs flex items-center justify-center hover:bg-gray-800"
                      >
                        ✕
                      </button>
                    </div>
                  ))}

                  {/* New Uploaded Files Preview */}
                  {updatedFiles.map((file, index) => (
                    <div
                      key={`new-${index}`}
                      className="relative rounded-md flex items-center justify-center"
                    >
                      <img src={pdfIcon} alt="PDF" className="w-10 h-10" />
                      <button
                        type="button"
                        onClick={() => {
                          setUpdatedFiles((prev) =>
                            prev.filter((_, i) => i !== index)
                          );
                          // Clear Formik's files field and trigger validation
                          setFieldValue("files", []);
                        }}
                        className="absolute -top-2 -right-2 bg-black text-white rounded-full w-5 h-5 text-xs flex items-center justify-center hover:bg-gray-800"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>

                {/* Submit Button */}
                <div className="w-full flex justify-between gap-3 mb-2 mt-4">
                  <button
                    type="submit"
                    className="button-field-primary"
                    style={{ width: "100%" }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </ModalPopup>

      <Pagination
        currentPage={currentPage}
        totalRows={totalRows}
        perPage={perPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        type="feeStructure"
      />

      <DeleteModal
        title="Delete Fee Structure"
        message="Are you sure you want to delete Fee Structure?
          It will erase all the data permanently."
        modalOpenDelete={modalOpenDelete}
        setmodalOpenDelete={setmodalOpenDelete}
        handleDelete={handleDelete} // Don't call it here
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        modalOpenDeleteSuccess={modalOpenDeleteSuccess}
        setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
        module={"Fee Structure"}
        redirectPage={"Admissions"}
        redirectUrl={
          mode === "view"
            ? `admin-school/view/${schoolId}`
            : role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin"
              ? "navigation-dashboard"
              : "admissions"
        }
      />
      {!isLoading && Data.length === 0 && (
        <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400">No Data Found</h1>
        </div>
      )}
    </>
  );
};

export default FeeStructure;
